  <template>
  <div class="incident-report-form pad">

    <h1 class="title is-3">Report An Incident</h1>

    <sdf-form v-if="data" :fields="formFields" :data="data" @input="onInput" ref="form" />

    <div class="buttons">
      <button class="button is-info" :class="{'is-loading': submitting}" @click="onSubmit()">Next</button>
    </div>

  </div>
</template>

<script>
import SdfForm from '@/components/SdfForm'
import { formFields } from '@/utils/incidents'
export default {
  components: { SdfForm },
  data () {
    return {
      formFields,
      data: null,
      submitting: false
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  created () {
    this.data = {
      name: `${this.user.firstName} ${this.user.lastName}`,
      phone: this.user.phone
    }
  },
  methods: {
    onInput (data, key) {
      if (key === 'type') {
        for (const item of this.formFields) {
          if (item.key === 'timeOfIncident') item.title = `Time of ${data.type} (e.g. 06:30am)`
          else if (item.key === 'incidentType') item.title = `${data.type} Type`
          else if (item.key === 'natureOfIncident') item.title = `Nature of ${data.type}`
          else if (item.incidentDetails) item.content = `${data.type} Details`
        }
      } else if (key === 'timeOfIncident') {
        let str = data.timeOfIncident.trim().toLocaleLowerCase()
        let amPm = ''
        if (str.endsWith('am') || str.endsWith('a')) amPm = 'am'
        else if (str.endsWith('pm') || str.endsWith('p')) amPm = 'pm'
        str = str.replace(/[^0-9]/g, '')
        if (str.length >= 2) {
          str = str.substr(0, 2)
        }
        data.timeOfIncident = str + amPm
      }
    },
    async onSubmit () {
      const details = this.$refs.form.submit()
      if (!details) {
        this.$showError('Please fill out all required fields.<p class="font-size-80">Fields with a title ending in * are required</p>', 'Form Incomplete')
        return
      }
      this.submitting = true
      const timestamp = this.$moment().unix()
      try {
        const data = {
          status: 'preparing',
          investigation: false,
          details,
          userId: this.user._id,
          reportingUser: this.user,
          timestampCreated: timestamp,
          updatedTimestamp: timestamp,
          witnesses: {},
          comments: []
        }
        data.witnesses[this.user._id] = {
          _id: this.user._id,
          firstName: this.user.firstName,
          lastName: this.user.lastName
        }
        console.log(data)
        const res = await this.$fs.collection('incidents').add(data)
        this.$router.push(`/incident/${res.id}`)
      } catch (error) {
        this.$showError(error)
      }

      this.submitting = false
    }
  }
}
</script>

<style>
  .incident-report-form label.b-radio {
    padding-right: 20px;
  }
</style>
